import { ArrowLeft } from 'lucide-react'
import { QuizSequenceInspector } from '@/components/inspection'

interface QuizSetInspectorProps {
  title: string
  quizIds: string[]
  onClose: () => void
}

export function QuizSetInspector({ title, quizIds, onClose }: QuizSetInspectorProps) {
  return (
    <div className="space-y-4">
      {/* 헤더 */}
      <div className="flex items-center gap-3">
        <button
          onClick={onClose}
          className="inline-flex items-center gap-1 px-3 py-1.5 text-sm border border-slate-300 rounded-lg hover:bg-slate-50"
        >
          <ArrowLeft className="w-4 h-4" />
          목록
        </button>
        <h2 className="text-base font-semibold text-slate-800">{title}</h2>
      </div>
      <QuizSequenceInspector quizIds={quizIds} sequenceKey={title} />
    </div>
  )
}
